export const TourStepId = {
  Welcome: 'tour-welcome',
  NotificationsBell: 'tour-notifications-bell',
  UserProfile: 'tour-user-profile',
  Sidebar: 'tour-sidebar',
  OrganSelector: 'tour-organ-selector',
  TileSelfAssessment: 'tour-tile-self-assessment',
  TileWorkshops: 'tour-tile-workshops',
  TileEvaluation: 'tour-tile-evaluation',
  Calendar: 'tour-calendar',
  SupportLogout: 'tour-support-logout',
} as const;

export type TourStepId = (typeof TourStepId)[keyof typeof TourStepId];
